var _path, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Youtube Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/facebook Copy 2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "M15.5303 11.0037C15.5308 9.91505 16.7439 9.26613 17.6499 9.86988L25.8325 15.325C26.6416 15.8649 26.6419 17.0544 25.8325 17.594L17.6499 23.0476C16.7438 23.6516 15.5305 23.0027 15.5303 21.9138V11.0037ZM18.2578 19.365L22.6172 16.4588L18.2578 13.5525V19.365Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7321_20518",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 12,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    d: "M15.5303 11.0037C15.5308 9.91505 16.7439 9.26613 17.6499 9.86988L25.8325 15.325C26.6416 15.8649 26.6419 17.0544 25.8325 17.594L17.6499 23.0476C16.7438 23.6516 15.5305 23.0027 15.5303 21.9138V11.0037ZM18.2578 19.365L22.6172 16.4588L18.2578 13.5525V19.365Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7321_20518)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M18.2124 2.97949C22.1547 2.97949 25.7962 3.13533 28.8193 3.33252C33.251 3.62159 36.7278 6.93524 37.0181 11.2676C37.1166 12.7378 37.1807 14.3223 37.1807 15.9565C37.1807 17.853 37.0948 19.7573 36.9683 21.5288C36.6525 25.9431 33.1722 29.3522 28.7212 29.6543C26.0041 29.8387 22.7958 29.9795 19.3271 29.9795C15.9051 29.9795 12.7397 29.8424 10.0503 29.6616C5.5626 29.36 2.04903 25.8975 1.72119 21.4292C1.58985 19.639 1.5 17.7552 1.5 15.9565C1.5 14.2673 1.57953 12.5709 1.69775 10.9819C2.01237 6.75368 5.30214 3.51827 9.54785 3.24609C11.9562 3.09171 14.8627 2.9795 18.2124 2.97949Z",
    stroke: "white",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3d6718826048eb98e25e647f22d7d6c2.svg";
export { ForwardRef as ReactComponent };